export const preventSymbols = (e) => {
  if (e.code === 'Minus' || e.code === 'Equal' || e.code === 'KeyE') {
    e.preventDefault();
  }
}

export const preventPasteNegative = (e) => {
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = parseFloat(clipboardData.getData('text'));

  if (pastedData < 0 || Number.isNaN(pastedData)) {
    e.preventDefault();
  }
}